export const SYMBOL_FUNCTION_MODE = Symbol.for('function:mode');

export enum FunctionModes {
  basic = 'basic',
  advanced = 'advanced'
}
